export { default } from "./QuizImageAnswer";
